import React, { useState } from "react";
import { toast } from "react-toastify";
import Axios from "../../api/Axios";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import storage from "../../Services/Storage";
const auth = storage.getLocal("user");
const SegmentModalNewCust = ({ stateProps }) => {

    const { segmentPopup, setSegmentPopup, setSegmentValue,segmentValue, segmentStreamList,setManualSegmentEnterBtn,setsegStatus } =
    stateProps;
    const [segmentStreamInput, setSegmentStreamInput] = useState(null);
    const [segmentChannelList, setSegmentChannelList] = useState([]);
    const [segmentChannelInput, setSegmentChannelInput] = useState(0);
    const [segmentSubChannelList, setSegmentSubChannelList] = useState([]);
    const [segmentSubChannelInput, setSegmentSubChannelInput] = useState(0);
    const [subSegmentDetailList, setSubSegmentDetailList] = useState([]);
    const [subSegmentDetailInput, setSubSegmentDetailInput] = useState(0);
  

    const handleClose = () => setSegmentPopup(false);
    const StreamTemplate = (stream) => {
        return <>{stream.STREAM_CHANNEL_CODE} - {stream.STREAM_CHANNEL_DESC}</>;
    };
    const ChannelTemplate = (channel) => {
        return <>{channel.STREAM_CHANNEL_CODE} - {channel.STREAM_CHANNEL_DESC}&nbsp;</>;
    };
    const SubChannelTemplate = (subchannel) => {
        return <>{subchannel.STREAM_CHANNEL_CODE} - {subchannel.STREAM_CHANNEL_DESC}&nbsp;</>;
    };
    const SubSegmentTemplete = (subdetail) => {
        return <>{subdetail.SEG_CODE} - {subdetail.SEG_DESC}&nbsp;</>;
    };

    const handleSegmentStream = async (e) => {
        if (e.target.value.STREAM_CHANNEL_ID !== undefined);
        {
            const channel_URL = "CustomerMast/GetChannel?";
            const channelApi = `${channel_URL}CICode=${auth.CICode}&SegparentId=${e.target.value.STREAM_CHANNEL_ID}&UserId=${auth.UserId}`;
            const channelRes = await Axios.get(channelApi);

            // const newChannelList = channelRes.data.filter((a) => {
            //   return (
            //     a.STREAM_CHANNEL_DESC == "RETAIL" ||
            //     a.STREAM_CHANNEL_DESC == "PCO IWS" ||
            //     a.STREAM_CHANNEL_DESC == "MCO IWS"
            //   );
            // });
            setSegmentChannelList(channelRes.data);
            setSegmentValue([]);
            setSegmentChannelInput([]);
            setSegmentSubChannelInput([]);
            setSubSegmentDetailInput([]);
        }
    };

    const handleSegmentChannel = async (e) => {
        if (e.target.value.STREAM_CHANNEL_ID !== undefined);
        {
            const subchannel_URL = "CustomerMast/GetSubChannel?";
            const subchannelApi = `${subchannel_URL}CICode=${auth.CICode}&SegparentId=${e.target.value.STREAM_CHANNEL_ID}`;
            const subchannelRes = await Axios.get(subchannelApi);

            // const newSegmentSubChannelList = subchannelRes.data.filter((a) => {
            //   return (
            //     a.STREAM_CHANNEL_DESC == "NFW (4 Wheeler)" ||
            //     a.STREAM_CHANNEL_DESC == "NFW(2 Wheelers)" ||
            //     a.STREAM_CHANNEL_DESC == "RETAIL"
            //   );
            // });
            setSegmentSubChannelList(subchannelRes.data);
            setSegmentSubChannelInput([]);
            setSubSegmentDetailInput([]);
            setSegmentValue([]);
        }
    };

    const handleSegmentSubChannel = async (e) => {
        if (e.target.value.STREAM_CHANNEL_ID !== undefined);
        {
            const segmentSubDetail_URL = "CustomerMast/GetSubSegmentDetail?";
            const subdetailApi = `${segmentSubDetail_URL}CICode=${auth.CICode}&SegparentId=${e.target.value.STREAM_CHANNEL_ID}`;
            const subdetailRes = await Axios.get(subdetailApi);

            setSubSegmentDetailList(subdetailRes.data);
            setSubSegmentDetailInput([]);
            setSegmentValue([]);
        }
    };
    const handleSubSegmentDetail = (e) => {
        if (e.target.value.SBSD_ID !== undefined) {
            setSegmentValue(e.target.value);
        }
    };
    
    return (
        <div>
            <>
                <div className="col-12 pt-0 pb-4">
                    <Dialog
                        header="Segment"
                        visible={segmentPopup}
                        style={{ width: "50vw" }}
                        draggable={false}
                        resizable={false}
                        onHide={handleClose}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                            <label className="form-label"> Stream</label>
                            <Dropdown
                                value={segmentStreamInput}
                                options={segmentStreamList}
                                onChange={(e) => {
                                    handleSegmentStream(e);
                                    setSegmentStreamInput(e.value);
                                }}
                                placeholder="Select a Stream Channel"
                                optionLabel="STREAM_CHANNEL_DESC"
                                itemTemplate={StreamTemplate}
                                emptyMessage="No data available"
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                            <label className="form-label"> Channel</label>
                            {/* segmentChannelList */}
                            <Dropdown
                                value={segmentChannelInput} 
                                options={segmentChannelList} 
                                onChange={(e) => {
                                    handleSegmentChannel(e);
                                    setSegmentChannelInput(e.value); 
                                }}
                                placeholder="Select a Stream Channel" 
                                optionLabel="STREAM_CHANNEL_DESC" 
                                itemTemplate={ChannelTemplate}
                                emptyMessage="No data available" 
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                            <label className="form-label"> Sub-Channel</label>
                            {/* segmentSubChannelList */}
                            <Dropdown
                                value={segmentSubChannelInput} 
                                options={segmentSubChannelList} 
                                onChange={(e) => {
                                    handleSegmentSubChannel(e);
                                    setSegmentSubChannelInput(e.value); 
                                }}
                                placeholder="Select a Stream Sub Channel" 
                                optionLabel="STREAM_CHANNEL_DESC" 
                                itemTemplate={SubChannelTemplate}
                                emptyMessage="No data available"
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                            <label className="form-label"> Sub-Segment detail</label>
                            {/* subSegmentDetailList */}
                            <Dropdown
                                value={subSegmentDetailInput} 
                                options={subSegmentDetailList} 
                                onChange={(e) => {
                                    handleSubSegmentDetail(e); 
                                    setSubSegmentDetailInput(e.value); 
                                }}
                                placeholder="Select a Sub Segment Detail" 
                                optionLabel="SEG_DESC" 
                                itemTemplate={SubSegmentTemplete}
                                emptyMessage="No data available" 
                            />
                        </div>

                        <div className="float-end mt-4">
                            <button
                                type="button"
                                className="btn btn-cancel me-3"
                                onClick={() => {
                                    setSegmentStreamInput([]);
                                    setSegmentChannelInput([]);
                                    setSegmentSubChannelInput([]);
                                    setSubSegmentDetailInput([]);
                                    setSegmentValue([]);
                                }}
                            >
                Clear
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    toast.warning(
                                        `Selected segment is  "${subSegmentDetailInput.SEG_DESC}" for the customer, after saving the segment cannot be edited.`,
                                        {
                                            position: toast.POSITION.TOP_CENTER,
                                            pauseOnFocusLoss: false,
                                            closeButton: false,
                                            autoClose: 8000,
                                        }
                                    );
                                    setManualSegmentEnterBtn(true);
                                    setSegmentPopup(false);
                                    setsegStatus(false);
                                }}
                                disabled={segmentValue.SBSD_ID==undefined}
                            >
                Confirm
                            </button>
                        </div>
                    </Dialog>
                </div>
            </>
        </div>
    );
};

export default SegmentModalNewCust;
